import { useTranslation } from 'react-i18next';
import { useCanUser } from 'shared-hooks/permission';

import { updateTask } from 'actions/tasks';
import { uploadFiles } from 'actions/files';

import DescriptionPane from 'components/description-pane';

const TaskDescription = ({ id, description, createdBy }) => {
    const { t } = useTranslation('task');
    const canEditTask = useCanUser('editTask', createdBy);

    const handleDescriptionChange = description => {
        updateTask(id, { description });
    }

    const handleFilesAdd = files => {
        uploadFiles(files, {
            task: id
        });
    }

    return (
        <DescriptionPane
            key={id}
            editable={canEditTask}
            placeholder={canEditTask ? t('Add task description') : undefined}
            content={description || ''}
            onChange={handleDescriptionChange}
            onFilesPaste={handleFilesAdd}
        />
    );
}

export default TaskDescription;
